import { ReactNode } from "react";
import { clsx } from "clsx";

interface BadgeProps {
  variant?: "default" | "success" | "warning" | "error" | "primary" | "info";
  children: ReactNode;
  className?: string;
}

const variantClass = {
  default: "def",
  success: "suc",
  warning: "war",
  error: "err",
  primary: "pri",
  info: "inf",
} as const;

export const Badge = ({ variant = "default", children, className }: BadgeProps) => {
  return <span className={clsx("b", variantClass[variant], className)}>{children}</span>;
};

export default Badge;
